import type { EraFilter, Round } from "../types";
import { ROUND_CATALOG as GENERATED_ROUND_CATALOG } from "./rounds.generated";

export const TOTAL_ROUNDS = 5;

export const ERA_FILTERS: Array<{ id: EraFilter; label: string; range: string }> = [
  { id: "all", label: "Full archive", range: "all years" },
  { id: "ancient", label: "Ancient", range: "before 500" },
  { id: "pre-modern", label: "Pre-modern", range: "500 to 1799" },
  { id: "modern", label: "Modern", range: "1800 onward" }
];

export const TIMELINE_RANGES: Record<EraFilter, { min: number; max: number; start: number }> = {
  all: { min: -35000, max: 2026, start: 1500 },
  ancient: { min: -35000, max: 499, start: -3000 },
  medieval: { min: 500, max: 1499, start: 1100 },
  "early-modern": { min: 1500, max: 1799, start: 1650 },
  "pre-modern": { min: 500, max: 1799, start: 1300 },
  modern: { min: 1800, max: 2026, start: 2000 }
};

export const ROUND_CATALOG: Round[] = GENERATED_ROUND_CATALOG;
